import Event from '@/orm/models/Event'
import Referee from '@/orm/models/Referee'
import RefereeRole from '@/orm/models/RefereeRole'
import EventCourse from '@model/EventCourse'
import { Model } from 'pinia-orm'
import { BelongsTo, Bool, Num, Str, Uid } from 'pinia-orm/decorators'

export default class EventReferee extends Model {
    static entity = 'events-referees'

    @Uid()
    declare id: string
    @Uid()
    declare eventId: string
    @BelongsTo(() => Event, 'eventId')
    declare event: Event
    @Str(null)
    declare refereeId: string | null
    @BelongsTo(() => Referee, 'refereeId')
    declare referee: Referee | null
    @Num(0, { notNullable: true })
    declare refereeRoleId: number
    @BelongsTo(() => RefereeRole, 'refereeRoleId')
    declare refereeRole: RefereeRole
    @Str(null)
    declare courseId: string
    @BelongsTo(() => EventCourse, 'courseId')
    declare course: EventCourse
    @Str(null)
    declare wsId: string | null
    @Bool(false)
    declare scorer: boolean
    @Str(null)
    declare foreignerFirstName: string | null
    @Str(null)
    declare foreignerLastName: string | null
    @Str(null)
    declare foreignerSex: string | null
    @Str(null)
    declare foreignerEmail: string | null
    @Str(null)
    declare foreignerPhone: string | null

    get dump() {
        return {
            refereeId: this.refereeId,
            refereeRoleId: this.refereeRoleId,
            course: this.courseId !== null ? this.course.title : null,
            wsId: this.wsId,
            scorer: this.scorer,
            foreignerFirstName: this.foreignerFirstName,
            foreignerLastName: this.foreignerLastName,
            foreignerSex: this.foreignerSex,
            foreignerEmail: this.foreignerEmail,
            foreignerPhone: this.foreignerPhone,
        }
    }

    get reverseFullName(): string {
        if (this.refereeId !== null)
            return this.referee?.reverseFullName ?? ''
        else
            return this.foreignerLastName + ' ' + this.foreignerFirstName
    }

    get sex() {
        return this.refereeId !== null ? this.referee?.sex : this.foreignerSex
    }

    get email() {
        return this.refereeId !== null ? this.referee?.email : this.foreignerEmail
    }

    get phone() {
        return this.refereeId !== null ? this.referee?.phone : this.foreignerPhone
    }

    get reverseFullNameWithIdentification() {
        return this.refereeId !== null
            ? this.referee?.reverseFullNameWithIdentification
            : ((this.wsId ?? '') + ' ' + this.reverseFullName).trim()
    }

    get identification() {
        return this.refereeId !== null ? this.referee?.identification : ''
    }

    get reverseFullNameWithId() {
        return this.refereeId !== null
            ? this.referee?.reverseFullNameWithId
            : ((this.wsId ?? '') + ' ' + this.reverseFullName).trim()
    }

    get firstName() {
        return this.refereeId !== null ? this.referee?.firstName : this.foreignerFirstName
    }

    get lastName() {
        return this.refereeId !== null ? this.referee?.lastName : this.foreignerLastName
    }

    static piniaOptions = {
        persist: false,
    }
}
